import { IItemEstadoDTO, ItemEstadoDTO } from "./ItemEstado.DTO";
import { obtenerIdPreguntaTipo, PreguntasTipoEnum } from "@shared/enums";
import { Nilable } from "@shared/utils";

export interface IPreguntaEstadoDTO {
    id: number;
    items: IItemEstadoDTO[];
    text: string;
    type: string;
}

export class PreguntaEstadoDTO {
    public id = 0;
    public items: ItemEstadoDTO[] = [];
    public texto = "";
    public tipo = PreguntasTipoEnum.SINGLE_CHOICE;

    constructor(json: Nilable<Partial<IPreguntaEstadoDTO>> = null) {
        if (json != null) {
            this.cargarDTO(json);
        }
    }

    public cargarDTO(json: Partial<IPreguntaEstadoDTO>) {
        if (json.id != null) {
            this.id = json.id;
        }
        if (json.items != null) {
            this.items = json.items.map(item => new ItemEstadoDTO(item));
        }
        if (json.text != null) {
            this.texto = json.text;
        }
        if (json.type != null) {
            this.tipo = PreguntasTipoEnum[json.type];
        }
    }

    public toJSON(): IPreguntaEstadoDTO {
        return {
            id: this.id,
            items: this.items.map(item => item.toJSON()),
            text: this.texto,
            type: obtenerIdPreguntaTipo(this.tipo)
        };
    }
}
